import moment from 'moment';

export default function headerPlanningFaceUnitaireReseauLc(h, start, end, mode = 'month') {
  const columns = [];
  if (mode === 'month') {
    const startMonth = moment(start);
    const endMonth = moment(end);
    const diff = moment.duration(endMonth.diff(startMonth)).asMonths();
    if (!Number.isNaN(diff)) {
      const monthsNumber = Math.round(diff);
      for (let i = 0; i < monthsNumber; i += 1) {
        const value = moment(start).add(i, 'months');
        columns.push(h('div', { class: { 'column-header': true } }, [h('span', null, value.format('MMMM'))]));
      }
    }
  }
  return h('div', {
    class: { 'planning-columns': true },
  }, columns);
}
